import React, { useState } from 'react';
import PreviewCanvas from './PreviewCanvas';
import AiBanner from './AiBanner';
import { useBlockApply } from './useBlockApply';
import './effectBlocks.css';

/**
 * FlipBlockEditor — panel block: mirror horizontally or vertically ->
 * hflip_tool / vflip_tool. The preview flips live via a CSS transform.
 */
function FlipBlockEditor({ videoWorkspaceId, frameUrl, sourceFileName, mediaInfo, aiSuggestion, onApplied, onClose }) {
    const { setMeasured, aspectRatio, ready, applying, error, apply } =
        useBlockApply({ videoWorkspaceId, sourceFileName, mediaInfo });
    const [direction, setDirection] = useState(aiSuggestion?.params?.direction || 'horizontal');

    return (
        <div className="eb-editor">
            <AiBanner rationale={aiSuggestion?.rationale} />
            <div className="eb-editor-grid">
                <PreviewCanvas
                    frameUrl={frameUrl}
                    isVideo
                    aspectRatio={aspectRatio}
                    blocks={[]}
                    onMeta={setMeasured}
                    onSelect={() => {}}
                    onChange={() => {}}
                    frameTransform={direction === 'horizontal' ? 'scaleX(-1)' : 'scaleY(-1)'}
                />
                <div className="eb-controls">
                    <h5>Flip</h5>
                    <div className="eb-ctl">
                        <span>Direction</span>
                        <div className="eb-seg">
                            <button type="button" aria-pressed={direction === 'horizontal'} onClick={() => setDirection('horizontal')}>Horizontal</button>
                            <button type="button" aria-pressed={direction === 'vertical'} onClick={() => setDirection('vertical')}>Vertical</button>
                        </div>
                    </div>
                    <p className="eb-hint">The preview shows the mirrored result.</p>

                    {error && <p className="eb-error">{error}</p>}

                    <div className="eb-actions">
                        {onClose && <button type="button" className="eb-btn" onClick={onClose}>Cancel</button>}
                        <button
                            type="button"
                            className="eb-btn primary"
                            disabled={!ready || applying}
                            onClick={() => apply({ type: 'flip', params: { direction } }, onApplied)}
                        >
                            {applying ? 'Applying…' : 'Add to timeline'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FlipBlockEditor;
